import React, { useState } from "react";

const InvestigativeAbility = (props) => {

    const abilityID = props.item.id;

    const [isExpanded, setIsExpanded] = useState(false);
    const [isIncrementing, setIsIncrementing] = useState(false);
    const [isDecrementing, setIsDecrementing] = useState(false);
    const [isFading, setIsFading] = useState(false);
    const [isAnimationDone, setIsAnimationDone] = useState(false);

    function pointCount() {
        return props.item.id in props.pointMap ? props.pointMap[props.item.id] : 0
    }

    function updatePointMap(updatedCount) {
        const copyMap = structuredClone(props.pointMap);
        copyMap[props.item.id] = updatedCount;
        props.setPointMap(copyMap);
        props.setPointMap(copyMap);
    }

    function recalculatePoints() {
        if (isIncrementing) {
            finishIncrementCount();
        } else if (isDecrementing) {
            finishDecrementCount();
        }
        setIsFading(false);
        setIsAnimationDone(true);
    }

    function startIncrementCount() {
        if (props.pointsRemaining > 0 && pointCount() < 1) {
            setIsIncrementing(true);
            setIsDecrementing(false);
            setIsFading(true);
            setIsAnimationDone(false);
            props.setAddedInvestigative(props.item);
            props.setRemovedInvestigative(null);
        }
    }

    function finishIncrementCount() {
        const count = pointCount();
        const updatedCount
            = props.pointsRemaining > 0 && count < 1 ? count + 1 : count;
        updatePointMap(updatedCount);
        
    }

    function startDecrementCount() {
        setIsIncrementing(false);
        setIsDecrementing(true);
        setIsFading(true);
        setIsAnimationDone(false);
        props.setRemovedInvestigative(props.item);
        props.setAddedInvestigative(null);
    }

    function finishDecrementCount() {
        const count = pointCount();
        const updatedCount = Math.max(0, count - 1);
        //setCount(updatedCount);
        updatePointMap(updatedCount);
        
    }

    // expand/collapse

    function toggleExpandDisplay() {
        setIsExpanded(!isExpanded);
    }

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    // classes

    const expandClasses = {
        'App-action-expandicon': true,
        'expand-icon--selected': isExpanded
    };

    const expandClassNames = classNames(expandClasses);

    const labelClasses = {
        'App--action-label': true,
        'Expand-half': true,
        'App--action-label-expand': isExpanded
    };

    const labelClassNames = classNames(labelClasses);

    const descriptionClasses = {
        'App--action-desc': true,
        'Expand-half': true,
        'App--action-desc-expand': isExpanded
    };

    const descriptionClassNames = classNames(descriptionClasses);

    const titleClasses = {
        'App--action-title-label': true,
        'App--action-title-label-expand': isExpanded,
        'Title-expand-half': isExpanded
    };

    const titleClassNames = classNames(titleClasses);

    const rowClasses = {
        'App--general-action-row': true,
        'Action-row-fade': isFading,
        'Action-row-fade-in': props.isNewRow && !isAnimationDone
    };

    const rowClassNames = classNames(rowClasses);

    return (
        <div className={rowClassNames}
            onAnimationEnd={() => recalculatePoints()}
        >
            <button type="button" onClick={toggleExpandDisplay} className="App--general-action-button">
                <div id={"action-display-" + abilityID} className="App-action-expand-button">
                    <div className={expandClassNames} />
                </div>
                <div className={labelClassNames}>
                    <div className={titleClassNames} >{props.item.name}</div>
                    <div className={descriptionClassNames}>
                        {props.item.description}
                    </div>
                </div>
            </button>
            <div className="App--investigative-action-points-box">
                {props.isLearned && (
                    <button type="button" className="App--investigative-action-points-adjust-button"
                        onClick={startDecrementCount}>
                        <div className="App--general-action-points-adjust-button-text">
                            <img alt="minus" src="./minus-button.png" width="40px" />
                        </div>
                    </button>)}
                {!props.isLearned && (
                    <button type="button" className="App--investigative-action-points-adjust-button"
                        onClick={startIncrementCount}>
                        <div className="App--general-action-points-adjust-button-text">
                            <img alt="plus" src="./plus-button.png" width="40px" />
                        </div>
                    </button>)}
            </div>
        </div>

    );
};

export default InvestigativeAbility;